export default {
    apiurl: process.env.REACT_APP_API_URL,
};
